import type { FC } from 'react';

import { FormTextarea } from '@zen/Components/Form';
import FormScoreSelect from '@zen/Components/Form/FormScoreSelect';
import LucaAvatar from '@zen/Components/LucaAvatar';

import { type Question, questions } from './helpers';

const renderField = ({ type, labels, name }: Question) => {
  if (type === 'score') {
    return <FormScoreSelect hintLabels={labels} name={name} />;
  }

  return <FormTextarea hideLabel={true} name={name} />;
};

const NetPromoterScoreQuestions: FC = () => {
  return (
    <div className="flex flex-col space-y-4" data-component="net-promoter-score-questions">
      {questions.map((question: Question) => (
        <div key={question.name}>
          <div className="font-bold mb-2">{question.question}</div>
          {renderField(question)}
        </div>
      ))}
      <div className="flex items-center space-x-2 justify-end mt-4">
        <LucaAvatar size="medium" />
        <div className="text-transparent bg-clip-text bg-sunset-base text-sm">Powered by Luca</div>
      </div>
    </div>
  );
};

export default NetPromoterScoreQuestions;
